import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <div className="flex flex-col items-center justify-center px-6 py-24 text-center">
        <p className="text-6xl font-bold text-green-800">404</p>
        <h1 className="mt-4 text-2xl font-semibold text-gray-800">
          Page not found
        </h1>
        <p className="mt-2 max-w-md text-gray-600">
          The page you're looking for doesn't exist or may have been moved.
          If you reached this from a city link, that city may not have been
          scraped yet.
        </p>
        <button
          onClick={() => navigate("/cities")}
          className="mt-6 rounded-md bg-green-800 px-4 py-2 text-white transition-colors hover:bg-green-900"
        >
          ← Back to Map
        </button>
      </div>
    </div>
  );
}